export const defaultLogger = () => {
	return {
		debug: console.debug,
		info: console.info,
		warn: console.warn,
		error: console.error
	}
};
